import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Shield, Lock, Globe, Check, Zap, Sparkles } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-cream relative" data-id="element-196">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg h-[500px] bg-turquoise/10 blur-[120px] rounded-full pointer-events-none" data-id="element-197"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-198">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy border-2 border-gold rounded-3xl p-1 relative shadow-[0_0_50px_rgba(23,168,160,0.15)]" data-id="element-199">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold-gradient text-white font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-200">
            <Sparkles size={14} data-id="element-201" /> Complete Spanish Teaching Bundle
          </div>

          <div className="bg-navy-dark rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-202">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-white mb-3" data-id="element-203">
              Spanish Ready™ Mega Pack
            </h3>
            <p className="text-base text-white/80 mb-6" data-id="element-204">
              6-in-1 complete system · 5 exclusive bonus packs · Ready to use
              from today
            </p>

            <div className="mb-6" data-id="element-205">
              <span className="text-lg text-gold/70 line-through block mb-1" data-id="element-206">
                USD 49.90
              </span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-207">
                <span className="text-2xl md:text-3xl text-white" data-id="element-208">Today:</span>
                <span className="text-4xl md:text-5xl font-bold text-turquoise" data-id="element-209">
                  $19.90
                </span>
              </div>
            </div>

            <Button href="https://spanish-ready.impultienda.ar/checkout" target="_blank" onLinkClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'InitiateCheckout', {
                content_name: 'Spanish Ready Mega Pack',
                value: 19.9,
                currency: 'USD'
              });
            }
          }} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-210">
              🟡 I WANT MY MEGA PACK — $19.90
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60 mb-6" data-id="element-211">
              <span className="flex items-center gap-1.5" data-id="element-212">
                <Lock size={12} className="text-turquoise" data-id="element-213" /> Secure payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-214">
                <Zap size={12} className="text-turquoise" data-id="element-215" /> Immediate access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-216">
                <Shield size={12} className="text-turquoise" data-id="element-217" /> 7-day guarantee
              </span>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-218">
              <Globe className="text-turquoise shrink-0 mt-0.5" size={14} data-id="element-219" />
              <p className="text-[11px] text-white/70 leading-snug" data-id="element-220">
                You pay in your local currency. The checkout system
                automatically adapts to the country from which you are
                purchasing.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}